import { z } from 'zod';
export const SsoRegisterUserSchema = z.object({
    accessToken: z.string(),
    domainSecret: z.string(),
});
